import { OrbitNoticeRequest } from './OrbitNoticeContext';

/**
 * `5143:1491`, the tick that leads the save-success bubble. It is a sibling NODE of the message,
 * not part of the string, which is why it is passed as the bubble's glyph and is not a copy key.
 * Both failure strings draw their warning sign inside the text node instead.
 */
export const ORBIT_SAVED_GLYPH = '✓';

/**
 * The three save-outcome bubbles Figma draws for the Orbit panel, each parameterised on the
 * investigation's own subject where the frame prints "Customer Engagement".
 *
 * `5032:11743` / `5143:1490` — the save succeeded and the panel is back on its home screen.
 * TODO(AF-10): PLA-8839 exposes `/v4/dash/orbit/requests` and `/v4/dash/orbit/sessions` only, so
 * nothing can save and nothing raises this yet. Its caller is the header's `orbit-sidebar-save`
 * glyph, which ships disabled for the same reason.
 */
export const orbitSavedNotice = (subject: string): OrbitNoticeRequest => ({
  tone: 'saved',
  messageKey: 'toast.saved',
  params: { subject },
  glyph: ORBIT_SAVED_GLYPH
});

/**
 * `5032:11882` / `5140:1483` — the save failed and the transcript is still on screen, which is what
 * separates it from the notice below. TODO(AF-10): same missing endpoint.
 */
export const orbitSaveFailedNotice = (subject: string): OrbitNoticeRequest => ({
  tone: 'failed',
  messageKey: 'toast.saveFailed',
  params: { subject }
});

/**
 * New Chat. The frames draw `5083:2479` / `5140:1486` here - "is not saved. New investigation
 * started." over the home panel - and that reading is RETIRED (user ruling, 2026-09-14): the
 * backend retains every conversation, `GET /v4/dash/orbit/requests?session_id` lists any past
 * session and the home panel's Recent Sessions block reopens it, so nothing is lost by starting a
 * new one. The notice keeps the frame's second half and ships in the SUCCESS variant
 * (`5032:11743`) - `positive` fill, the same tick node - because what it reports is a confirmation.
 */
export const orbitNewInvestigationNotice = (subject: string): OrbitNoticeRequest => ({
  tone: 'saved',
  messageKey: 'toast.newInvestigation',
  params: { subject },
  glyph: ORBIT_SAVED_GLYPH
});
